import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "app-new-registration",
  templateUrl: "./new-registration.component.html",
})
export class NewRegistrationComponent implements OnInit {

  public serviceId: string;
  public determinantMapById: { [key: string]: string } = {};

  @Output() public modalClosedEvent = new EventEmitter();

  constructor(private route: ActivatedRoute, private determinantService: DeterminantControllerService,
              private router: Router) {
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.getServiceDeterminantKeyName();
    });
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public navigateToRegistration(registrationId: string) {
    this.router.navigate(["/services/" + this.serviceId + "/registrations/" + registrationId]);
  }

}
